import { render, staticRenderFns } from "./ScoreRegistration.vue?vue&type=template&id=0f88aa98&scoped=true&"
import script from "./ScoreRegistration.vue?vue&type=script&lang=js&"
export * from "./ScoreRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ScoreRegistration.vue?vue&type=style&index=0&id=0f88aa98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88aa98",
  null
  
)

export default component.exports